import { render, staticRenderFns } from "./HistorialCirtas.vue?vue&type=template&id=6c3d7392&scoped=true"
import script from "./HistorialCirtas.vue?vue&type=script&lang=js"
export * from "./HistorialCirtas.vue?vue&type=script&lang=js"
import style0 from "./HistorialCirtas.vue?vue&type=style&index=0&id=6c3d7392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d7392",
  null
  
)

export default component.exports